module.exports = __webpack_public_path__ + "831f540763a0b91e7a94c58eb4125036.pdf";